export const messages_en = {
  error_default: "Something went wrong :(",
  error_oops: "Oops!",
  error_options: "Consider one of the following actions",
  username_taken: "Username is already taken",
  email_taken: "Email is already taken",
  passwords_not_matching: "Passwords do not match. ",
  password_too_short: "Password needs to be at least {0} characters long. ",
  password_needs_digit: "Password needs to include at least one digit. ",
  password_needs_uppercased:
    "Password needs to include at least one uppercased letter. ",
  password_needs_lowercased:
    "Password needs to include at least one lowercased letter. ",
  password_not_allowed_special:
    "Password must not contain any special characters. ",
  registration_succes: "You have sucessfully registered!",
  serverError:
    "An error occurred during the communication with the server! Please try again or contact the system administrator.",
  delete_selected_confirm_message:
    "Are you sure you want to delete selected items?",
  documentsDeleteSuccess: "Document(s) has been successfully deleted!",
  documentsUploadSuccess: "Document(s) has been successfully uploaded!",
  nothingSelectedMessage:
    "There is no selected item. Please select item you want to delete.",
  changesNotSavedMessage:
    "You have unsaved changes, are you sure you want to leave?",
  reactivate_confirm_message: "Are you sure you want to reactivate item?",
  deactivate_confirm_message: "Are you sure you want to deactivate item?",
  clientError:
    "An error occurred on the client! Please try again or contact the system administrator.",
  settingsSaveSuccess: "Settings successfully saved!",
  existingElementAdditionWarning: "You tried to add an existing item!",
  notificationsUnsupportedMessage:
    "This browser does not support notifications. Switch to another browser or try updating the current one in order to receive notifications.",
  webSocketsUnsupportedMessage:
    "This browser does not support the use of web-sockets. Switch to another browser or try updating the current one in order to receive real-time notifications.",
  disabledSaveButtonTooltip:
    "Saving is currently not allowed. It is necessary to fill in all mandatory data.",
  usernamePasswordMandatory: "It is necessary to enter username and password!",
  "searchable.true": "Content of this document is searchable.",
  "searchable.false":
    "Content of this document is not searchable. For further clarification contact the administrator.",
  "searchable.wait":
    "Document is currently processing. Please wait and check later.",
  changesNotSavedWarn: "You have unsaved changes that will be lost.",
  download_confirm_message: "Are you sure you want to download file?",
  download_url_confirm_message: "Are you sure you want to download multimedia file?",
  preview_url_confirm_message: "Are you sure you want to preview multimedia file?",
  empty_files_unzipped_message:
    "File sucessfully unzipped and saved, but these files inside were empty and thus not saved:"
};
